import React from 'react';

const HOC = (props)=>{
    return props.children
};

export default HOC;


// WEBPACK FOOTER //
// ./src/routes/HOC.js